import PropTypes from 'prop-types';

const COLOR_SCHEMA = {
  true: {
    bg: '#FFF',
    primary: '#FFF',
    white: '#FFF',
    strokeProps: {
      stroke: '#000',
      strokeWidth: 2
    }
  },
  false: {
    bg: '#FFCCEF',
    primary: '#FB6E44',
    white: '#F4EFED',
    strokeProps: {
      stroke: null,
      strokeWidth: null
    }
  }
};

const PrivateLandlord = ({ negative = false }) => (
  <svg
    width="104"
    height="104"
    viewBox="0 0 104 104"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="52" cy="52" r="52" fill={COLOR_SCHEMA[negative].bg} />
    <path
      d="M23.8799 41.72V81.24H40.2302V62.987C40.2302 56.408 45.5107 51.0545 51.9999 51.0545C58.4891 51.0545 63.7696 56.408 63.7696 62.987V81.24H80.1199V41.72H23.8799Z"
      fill={COLOR_SCHEMA[negative].white}
      {...COLOR_SCHEMA[negative].strokeProps}
    />
    <path
      d="M80.1199 41.72L52.9372 41.72L23.8799 41.72L51.9999 17.4L80.1199 41.72Z"
      fill={COLOR_SCHEMA[negative].primary}
      {...COLOR_SCHEMA[negative].strokeProps}
    />
  </svg>
);

PrivateLandlord.propTypes = {
  negative: PropTypes.bool
};

export default PrivateLandlord;
